import ETImage from "../Pages/AdminPanel/Assets/Images/ET3.png";
import LiveLogo from "../Pages/AdminPanel/Assets/Images/Live_logo.svg";
import MainLogo from "../Assets/img/cantileverlogoblack.png";

export default function StdLiveNavBar() {
	return (
		<div
			className="flex justify-between sticky top-0 bg-white z-50 sm:mx-2"
			style={{ marginTop: "20px" }}
		>
			<div className="flex items-center">
				<img
					src={ETImage}
					alt="exam tracker"
					height={40}
					width={40}
					className="inline-block"
				/>
				<span className="text-2xl pl-2 flex items-end">
					<span className="mr-2 hidden sm:inline">Exam Tracker </span>
					<img
						src={LiveLogo}
						alt="live logo"
						height={24}
						width="auto"
					/>
				</span>
			</div>
			<div>
				<img
					src={MainLogo}
					alt="CantileverLabs logo"
					className="h-8 sm:h-12"
				/>
			</div>
		</div>
	);
}
